export interface BibliographySearchNarrowCondition {
  title: string
  author: string
  publisher: string
  materialFormat: string
  freeWord: string
}

export const defaultBibliographySearchNarrowCondition = (): BibliographySearchNarrowCondition => ({
  title: '',
  author: '',
  publisher: '',
  materialFormat: '',
  freeWord: ''
})

export function BibliographySearchNarrowConditionToJSON(
  value: BibliographySearchNarrowCondition
) {
  return {
    title: value.title !== '' ? value.title : undefined,
    author: value.author !== '' ? value.author : undefined,
    publisher: value.publisher !== '' ? value.publisher : undefined,
    material_format:
      value.materialFormat !== '' ? value.materialFormat : undefined,
    free_word: value.freeWord !== '' ? value.freeWord : undefined
  }
}
